import React from "react"
import parse, { DOMNode, domToReact, HTMLReactParserOptions, Element } from "html-react-parser"
import { Children } from "../custom-types"

type Props = {
  seo?: {
    fullHead: string
    metaRobotsNoindex: string
    metaRobotsNofollow: string
  },
  children?: Children
}

// SEO is generated from the YOAST plugin so we just parse that HTML
const Seo: React.FC<Props> = ({seo, children }) => {

  const options: HTMLReactParserOptions = {
    replace: (domNode: DOMNode) => {
      if(domNode instanceof Element) {
        const { attribs } = domNode
        if(attribs.rel === 'canonical' && attribs.href !== `https://www.rula.com`) {
          attribs.href = `https://www.rula.com${attribs.href}`
        }
      }
    }
  }

  return (
   <>
      <meta name="robots" content={`${seo?.metaRobotsNoindex}, ${seo?.metaRobotsNofollow}`}/>
      {seo?.fullHead && parse(seo.fullHead, options)}
      {children}
    </>
  )
}

export default Seo
